/* The spacing rule the Review chip claims to implement:
 * P(recall) = 2^(−Δt/h). Passing a chapter starts h at 1 day; each later
 * successful review moves it to the next interval, so a chapter comes back at
 * 1, 3, 7, then 21 days. Below TARGET it is due, and a failed review restarts
 * the interval. */
import { SRS } from '../data/srs';
import type { RevRow } from '../types';

export { SRS };

export function pRecall(row: RevRow | null | undefined, now = Date.now()): number {
  if (!row) return 1;
  return Math.pow(2, -((now - row.ts) / SRS.DAY) / row.h);
}

export function isDue(row: RevRow | null | undefined, now = Date.now()): boolean {
  return !!row && pRecall(row, now) < SRS.TARGET;
}

export function nextInterval(row: RevRow | null | undefined): RevRow {
  const k = row?.n ?? 0;
  return {
    h: SRS.HALF[Math.min(SRS.HALF.length - 1, k)],
    n: Math.min(SRS.HALF.length - 1, k + 1),
    ts: Date.now(),
  };
}

export function restartedInterval(): RevRow {
  return { h: 1, n: 0, ts: Date.now() };
}

/* Days since the last successful review, for the "1 d / today" chip. */
export function daysSince(row: RevRow, now = Date.now()): number {
  return Math.round((now - row.ts) / SRS.DAY);
}
